import React from "react";
import Notes from "../../../../components/patient-detail/notes";
import MonitoringCard from "../../../../components/patient-detail/monitoring";
import styles from "../DailiesDetailsLayout.module.css";

/**
 * DailiesRightPanel — Merged right column with Summary, Monitoring, and Notes sections.
 *
 * Layout structure:
 *   ┌──────────────────┐
 *   │  Summary Section │
 *   ├──────────────────┤
 *   │ RPM Monitoring   │
 *   │ (time tracking)  │
 *   ├──────────────────┤
 *   │  Notes Section   │
 *   │  (timeline)      │
 *   └──────────────────┘
 *
 * Matches the DetailsTab pattern with RPMMonitoringPanel + NotesAIPanel,
 * but adds Summary at the top for the Dailies workflow.
 */
const DailiesRightPanel = ({
  patientId,
  summary,
  summaryLoading,
  noteType = "rpm_note",
  caseManager = true,
  defaultTimer = {},
  resetTimer = () => {},
}) => {
  const chatBotType = noteType === "ccm_note" ? "CCM" : "RPM";

  return (
    <div className={styles.rightCard}>
      {/* Summary Section */}
      <div className={styles.cardSection}>
          <h4 className={styles.summaryHeading}>TOCA AI Insights</h4>

        <div className={styles.summarySection}>
          {summaryLoading ? (
            <p className={styles.summaryContent}>Loading summary...</p>
          ) : summary ? (
            <p className={styles.summaryContent}>{summary}</p>
          ) : (
            <p className={styles.summaryContent}>
              No summary available for this patient.
            </p>
          )}
        </div>
      </div>

      {/* Monitoring Section */}
      <div className={styles.cardSection}>
        <div className={styles.dailiesMonitoringWrapper}>
          <MonitoringCard
            key={patientId}
            patientId={patientId}
            noteType={noteType}
            caseManager={caseManager}
            title={"Notes"}
            hideLabels="true"
            defaultTimer={defaultTimer}
            resetTimer={resetTimer}
            requireTime={false}
            showNotesHistory
          />
        </div>
      </div>


    </div>
  );
};

export default DailiesRightPanel;
